import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { JwtService } from "./jwt.service";

@Injectable()
export class AdminOrdersService {

  constructor(
    private http: HttpClient,
    private jwtService: JwtService
  ){
  }

  private get token() {
    return this.jwtService.getTocken() ?? '';
  }  

  get headers(): HttpHeaders {
    return new HttpHeaders({
      //Authorization: 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxIiwianRpIjoiNTJhZmQ2YjdiZjRjNTEyZGMwMzU0ZmMxMWFmOGQ4N2ZmOWRhM2M0ODdkYWQ4YTE5MzUyYTk3YjFjZGRjZjQyYWZmMWM4ZWQwZmQ0MTNjZWMiLCJpYXQiOjE2NTExNDExODguMzI1ODY5LCJuYmYiOjE2NTExNDExODguMzI1ODcxLCJleHAiOjE2ODI2NzcxODguMzIwODIsInN1YiI6IjIiLCJzY29wZXMiOltdfQ.GlCtjQhjWrlnamUFVb68QFavn51IdH0iFCcuK3kT5UgGtjkPftRgvES_S-DCj76w7AhTWP6TQ7r1qKXwV_siuUbPktsctCbTPubayKy3LtiaT59jDg54py7sAjg6e9gws1w64BX6HgCJrvpkK97_fvsrdaeDVGteKR-jOTD7fjsoRfPeqTGDgNaM81JuDDjcQOHfiR3x7P0FJHSx4WB38F3mu-Edz6OwrlnLbAuCHUN1ueC1xjFvUAcTJ49rzJekXhnD-hPJeAOw89f18-MGAw4qPG_OZI7LuxvyO859h-HExWJ3quPZWzbdNWCgGran8JiLMty5jq5gO2LzrLidOwjtjjpCWmT-sTeV5ptKWLac1gaxS8lqDmCJs0khogX59muV2zZR0rEw0O_Ie5JWwuzGU-ofBAIPv0wIm-kGJAadeU6EPLHZN1QHZiVWorxav1LTgtVjmpMIi5GLnehvpLcxhrUaDblLcMmXRumfBQNs0RDyf8_MljOd4T1p3Eg1PKAuWyvOFKPsNAe1cRzJDuYJxIunsC38HWg-AL8iHFY99VM6MHPvySjUNPeK311loEykIuN3nhwVaOHrVtuhJoE432FD-wzNt802DjXPFJfxWTNXfPuZEoUA56S-2i8vKgjIh8PrXKjzG3J0xOkpTacbKyGYnGTxgWDCiznaCuU'
      Authorization: 'Bearer ' + this.token
    });
}

  getOrderStatuses(){
    let url = environment.apiUrl + '/orderStatuses';
    return this.http.get(url, {});
  }

  getCurrencies(){
    let url = environment.apiUrl + '/currencies';
    return this.http.get(url, {});
  }

  getParametrs(){
    let url = environment.apiUrl + '/parametrs';
    return this.http.get(url, {});
  }
  //page: number, 
  getOrders(nextPageUrl?:string, search?:string, delivered = false, isArchive = false): Observable<any> {
    let url = '';
    if(isArchive) {
      url = environment.apiUrl + `/operator/ordersArchive?${search ? search: ''}&isArchive=true`;
    } else {
      if(nextPageUrl && nextPageUrl !== ''){
        url = `${nextPageUrl}${search ? search: ''}`
      } else {
        url = environment.apiUrl + `/operator/orders?${search ? search: ''}`;
      }
    }
    if(delivered) {
      url +='&status_id=6&status=Įteiktas'
    }
    return this.http.get(url, {headers: this.headers});
  }

  getArchiveOrders(page: number, search?:string, delivered = false, isArchive = false): Observable<any> {
    let url = '';
    url = environment.apiUrl + `/operator/ordersArchive?count=20&page=${page}${search ? search: ''}&isArchive=true`;
    if(delivered) {
      url +='&status_id=6&status=Įteiktas'
    }
    return this.http.get(url, {headers: this.headers});
  }

  geNewOrders(nextPageUrl?:string, search?:string): Observable<any> {

    let url = '';
    //url = environment.apiUrl + `/operator/newOrders?count=20&page=${page}${search?search:''}`;
    if(nextPageUrl && nextPageUrl !== ''){
      url = `${nextPageUrl}${search ? search: ''}`
    } else {
      url = environment.apiUrl + `/operator/newOrders?${search ? search: ''}`;
    }

    return this.http.get(url, {headers: this.headers});
  }

  getOrder(id:number): Observable<any> {
    let url = environment.apiUrl + `/operator/order/${id}`;
    return this.http.get(url, {headers: this.headers, observe: 'response'});
  }
  
  setDraftInvoices(body:any){
    let url = environment.apiUrl + `/operator/draftInvoices`;
    return this.http.post(url, body, {headers: this.headers, observe: 'response'});
  }

  recalcDraftInvoices(id:number, body:any){
    let url = environment.apiUrl + `/operator/recalculate/${id}`;
    return this.http.post(url, body, {headers: this.headers, observe: 'response'});
  }

  orderDetailsChange(body:any){
    let url = environment.apiUrl + `/operator/orderDetailsChange`;
    return this.http.post(url, body, {headers: this.headers, observe: 'response'});
  }

  orderDetailEdit(id:number,body:any){
    let url = environment.apiUrl + `/operator/orderDetail/${id}`;
    return this.http.post(url, body, {headers: this.headers, observe: 'response'});
  }

  orderDetailSave(id:number,body:any){
    let url = environment.apiUrl + `/operator/order/${id}`;
    return this.http.post(url, body, {headers: this.headers, observe: 'response'});
  }

  orderDetailDelete(id:number){
    let url = environment.apiUrl + `/operator/orderDetail/${id}`;
    return this.http.delete(url, {headers: this.headers, observe: 'response'});
  }

  orderPicChange(body: FormData, id:number) {
    let url = environment.apiUrl + `/operator/orderDetailPhoto/${id}`;
    return this.http.post(url, body, {headers: this.headers});
  }

  deleteOrder(id: number) {
    let url = environment.apiUrl + `/operator/order/${id}`;
    return this.http.delete(url);
  }
}